import React, { useState, useEffect } from "react";
import {
  Box,
  Group,
  rem,
  Stack,
  Title,
} from "@mantine/core";
import DocsHeader from "./DocsHeader";
import DocsFooter from "./docsFooter";
import { PAGES } from "./docsIndex";
import DocsServiceNotice from "./DocsServiceNotice";

const DocsIndexContainer: React.FC = () => {
  const [hasLoaded, setHasLoaded] = useState(false);
  const [isLoggedIn, setIsLoggedIn] = useState(false);

  useEffect(() => {
    const rootDiv = document.getElementById("root");
    const pageData = JSON.parse(rootDiv?.dataset.hydrate || "{}");

    console.log("Page Data:", pageData);
    document.title = `Rizful Node Documentation`;
    setIsLoggedIn(pageData.is_logged_in);
    setHasLoaded(true);
  }, []);

  const items = Object.values(PAGES).map((page) => (
    <div key={page.slug}>
      <Box<"a">
        component="a"
        href={`/docs/${page.slug}`}
        className="link"
        style={{
          paddingLeft: "var(--mantine-spacing-md)",
        }}
      >
        {page.title}
      </Box>
      <div>
        {page.ARTICLES.map((article) => (
          <Box<"a">
            component="a"
            href={`/docs/${page.slug}/${article.slug}`}
            key={`/docs/${page.slug}/${article.slug}`}
            className="link"
            style={{
              display: "flex",
              alignItems: "center",
              gap: "var(--mantine-spacing-xs)",
              paddingLeft: "calc(2 * var(--mantine-spacing-md))",
            }}
          >
            {article.icon}
            {article.title}
          </Box>
        ))}
      </div>
    </div>
  ));

  if (!hasLoaded) {
    return <div>Loading...</div>;
  }

  return (
    <>
      <DocsHeader is_logged_in={isLoggedIn} />
      <Stack gap="lg" style={{ padding: "var(--mantine-spacing-lg)" }}>
        <Group>
          <Title order={3}>Rizful Node Documentation</Title>
        </Group>
        <DocsServiceNotice includeInvoiceDecoder />
        {items}
      </Stack>
      <DocsFooter />
      <style>
        {`
          .link {
            display: block;
            text-decoration: none;
            color: var(--mantine-color-text);
            line-height: 1.2;
            font-size: var(--mantine-font-size-sm);
            padding: var(--mantine-spacing-xs);
            border-top-right-radius: var(--mantine-radius-sm);
            border-bottom-right-radius: var(--mantine-radius-sm);
            border-left: ${rem(
              1
            )} solid light-dark(var(--mantine-color-gray-3), var(--mantine-color-dark-4));
            transition: background-color 0.3s, color 0.3s;
          }

          .link:hover {
            background-color: light-dark(
              var(--mantine-color-gray-0),
              var(--mantine-color-dark-6)
            );
          }

          .linkActive {
            font-weight: 500;
            border-left-color: light-dark(
              var(--mantine-color-blue-6),
              var(--mantine-color-blue-4)
            );
            color: light-dark(var(--mantine-color-blue-6), var(--mantine-color-blue-4));
          }

          .linkActive,
          .linkActive:hover {
            background-color: var(--mantine-color-blue-light) !important;
          }
        `}
      </style>
    </>
  );
};

export default DocsIndexContainer;
